webpackJsonp([256764309613460],{

/***/ 595:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _gatsbyLink = __webpack_require__(3);
	
	var _gatsbyLink2 = _interopRequireDefault(_gatsbyLink);
	
	var _LoreHookModels = __webpack_require__(55);
	
	var _LoreHookModels2 = _interopRequireDefault(_LoreHookModels);
	
	var _Markdown = __webpack_require__(5);
	
	var _Markdown2 = _interopRequireDefault(_Markdown);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = function (props) {
	  return _react2.default.createElement(
	    _LoreHookModels2.default,
	    null,
	    _react2.default.createElement(
	      'h1',
	      null,
	      'Overview'
	    ),
	    _react2.default.createElement(
	      'p',
	      null,
	      'If you\'re only consuming data from a single API, you\'ll never need to modify this file. But once you start consuming data from multiple APIs, you\'ll need to tell Lore which models are associated with each connection.'
	    ),
	    _react2.default.createElement(
	      'p',
	      null,
	      'If your application interacts with multiple APIs, create a connection for each API and then define which models are associated with each connection here.'
	    ),
	    _react2.default.createElement(_Markdown2.default, { text: '\n      module.exports = {\n\n        defaultConnection: \'default\'\n\n        connectionModelMap: {\n          default: [],\n          v1: [\n            \'currentUser\',\n            \'author\'\n          ],\n          v2: [\n            \'book\',\n            \'publisher\'\n          ]\n        }\n\n      };\n      ' }),
	    _react2.default.createElement(
	      'p',
	      null,
	      'In the example above, the models ',
	      _react2.default.createElement(
	        'code',
	        null,
	        'currentUser'
	      ),
	      ' and ',
	      _react2.default.createElement(
	        'code',
	        null,
	        'author'
	      ),
	      ' use the ',
	      _react2.default.createElement(
	        'code',
	        null,
	        'v1'
	      ),
	      ' connection, while the ',
	      _react2.default.createElement(
	        'code',
	        null,
	        'book'
	      ),
	      ' and ',
	      _react2.default.createElement(
	        'code',
	        null,
	        'publisher'
	      ),
	      ' models use the ',
	      _react2.default.createElement(
	        'code',
	        null,
	        'v2'
	      ),
	      ' connection. All other models use the ',
	      _react2.default.createElement(
	        'code',
	        null,
	        'default'
	      ),
	      ' connection.'
	    )
	  );
	};
	
	module.exports = exports['default'];

/***/ })

});


// WEBPACK FOOTER //
// component---src-pages-hooks-lore-hook-models-usage-index-js-9caebd6f1d123d245a90.js